import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getClassifiers } from "../../services/api";

export interface ClassifierState {
  classifierData: {
    data: any;
    status: null | 'idle' | 'loading' | 'failed';
  };
}

const initialState: ClassifierState = {
  classifierData: {
    data: [],
    status: null,
  },
};

export const getClassifiersAsync: any | null = createAsyncThunk(
  'classifier/getClassifiers',
  async (data: any) => {
    const response = await getClassifiers({ classifierTypeId: data.classifierTypeId });
    return response;
  },
);

export const classifierSlice = createSlice({
  name: 'classifier',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClassifiersAsync.pending, (state) => {
        state.classifierData.status = 'loading';
      })
      .addCase(getClassifiersAsync.fulfilled, (state, action) => {
        state.classifierData.status = 'idle';
        state.classifierData.data = action.payload?.data?.item?.items;
      })
      .addCase(getClassifiersAsync.rejected, (state) => {
        state.classifierData.status = 'failed';
      });
  },
});

export default classifierSlice.reducer;
